import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { ref, onValue } from 'firebase/database';
import { database } from '../../utils/firebase';

const MatchReport = () => {
    const { leagueId, matchId, print, header } = useParams();
    const [matchDetails, setMatchDetails] = useState({});
    const [players, setPlayers] = useState([]);
    const [leagueSettings, setLeagueSettings] = useState({});
    const [flights, setFlights] = useState([]);
    const [leagueData, setLeagueData] = useState({});
    const [otherPayouts, setOtherPayouts] = useState([]);
    const [payoutSet, setPayoutSet] = useState({});

    useEffect(() => {
        const leagueRef = ref(database, `leagues/${leagueId}/settings`);
        onValue(leagueRef, (snapshot) => {
            const data = snapshot.val();
            if (data) {
                setLeagueSettings(data);
            }
        });
    }, [leagueId]);

    useEffect(() => {
        const leagueRef = ref(database, `leagues/${leagueId}`);
        onValue(leagueRef, (snapshot) => {
            const data = snapshot.val();
            if (data) {
                setLeagueData(data);
                setLeagueSettings(data.settings || {});
                const matchData = data.matches[matchId];
                if (matchData) {
                    setMatchDetails(matchData);
                    const matchDate = matchData.dateTime * 1000;
                    const relevantHandicapSet = Object.values(data.handicaps || {}).find(handicapSet => {
                        return handicapSet.startDate * 1000 <= matchDate && matchDate <= handicapSet.endDate * 1000;
                    });
                    setFlights(Object.values(relevantHandicapSet?.flights || {}));
                    const activePlayers = Object.keys(data.players || {}).map(playerId => ({
                        ...data.players[playerId],
                        handicap: relevantHandicapSet?.playerHandicaps[playerId] || 0,
                        gross: matchData.scores[playerId]?.gross || 0,
                        net: matchData.scores[playerId]?.net || 0
                    }));
                    setPlayers(activePlayers);

                    // Find the relevant payout set based on the match date
                    const relevantPayoutSet = Object.values(data.payouts || {}).find(payoutSet => {
                        return payoutSet.startDate * 1000 <= matchDate && matchDate <= payoutSet.endDate * 1000;
                    });
                    setPayoutSet(relevantPayoutSet || {});
                    setOtherPayouts(matchData.otherPayouts || []);
                }
            }
            if (print === 'true') {
                setTimeout(() => {
                    window.print();
                }, 100);
            }
        });
    }, [leagueId, matchId]);

    const formatDate = (timestamp) => {
        const options = { month: 'short', day: 'numeric', year: 'numeric' };
        return new Date(timestamp * 1000).toLocaleDateString(leagueSettings.language, options);
    };

    const formatTime = (timestamp) => {
        const options = { hour: 'numeric', minute: 'numeric', hour12: true, timeZone: leagueSettings.timeZone };
        return new Date(timestamp * 1000).toLocaleTimeString(leagueSettings.language, options);
    };

    return (
        <div style={{backgroundColor: '#ffffff'}}>
            <div className={'modern-report report-container'}>
                <div className="modern-report-container">
                    {header === 'true' && (
                        <div className={'modern-report-header'} style={{ padding: '5px 0' }}>
                            <h1 style={{ margin: '5px 0', fontSize: '1.2em' }}>Match Report</h1>
                            <h3 style={{ margin: '5px 0', fontSize: '1em' }}>{leagueData.name}</h3>
                            <h4 style={{ margin: '5px 0', fontSize: '0.8em' }}>{leagueData.parentGroup}</h4>
                            <h4 style={{ margin: '5px 0', fontSize: '0.8em' }}>{matchDetails.name}</h4>
                            <h4 style={{ margin: '5px 0', fontSize: '0.8em' }}>{matchDetails.dateTime ? `${formatDate(matchDetails.dateTime)} - ${formatTime(matchDetails.dateTime)}` : ''}</h4>
                        </div>
                    )}
                    <div className="tables-container">
                        {flights.map((flight, flightIndex) => (
                            <div key={flightIndex} className="flight-table">
                                <h3 style={{marginLeft: "15px"}}>{flight.name}</h3>
                                <table>
                                    <thead>
                                        <tr>
                                            <th width="40%">Player Name</th>
                                            <th width="20%">Gross</th>
                                            <th width="20%">HC</th>
                                            <th width="20%">Net</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {players.filter(player => player.handicap >= Number(flight.start) && player.handicap <= Number(flight.end)).map((player, index) => (
                                            <tr key={index}>
                                                <td>{player.name}</td>
                                                <td>{player.gross !== 0 ? player.gross : ''}</td>
                                                <td>{player.handicap}</td>
                                                <td>{player.net !== 0 ? player.net : ''}</td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div>
                        ))}
                    </div>
                    <div style={{ display: 'flex', flexDirection: 'row', gap: '20px' }}>
                        {payoutSet.otherPayouts && payoutSet.otherPayouts.map((payout, index) => (
                            <div key={index} className="payouts-container">
                                <h3 style={{marginLeft: "15px"}}>{payout.name}</h3>
                                <table style={{width: "350px"}}>
                                    <thead>
                                        <tr>
                                            <th width={"150px"}>Name</th>
                                            {payout.holeBound && <th width={'100px'}>Hole Number</th>}
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {Object.entries(otherPayouts[index] || {}).map(([key, playerId]) => (
                                            <tr key={key}>
                                                <td>{leagueData.players[playerId]?.name || 'Unknown Player'}</td>
                                                {payout.holeBound && <td>{key}</td>}
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default MatchReport;